<template>
  <div 
    :class="{['BG_Gray_01']:!this.$store.state.isMobile}"
    :style="{display: this.$store.state.isMobile ? '' : 'flex', justifyContent: this.$store.state.isMobile ? '' : 'center' }"
  >
    <div :style="{
        width: this.$store.state.isMobile ? '100%' : '600px',
        boxShadow: this.$store.state.isMobile ? '' : '0px 2px 10px 0px rgba(0, 0, 0, 0.10)'
      }"
      style="background-color: #ffff;"
    >
      <div :class="[`wrap ${this.$store.state.theme.font}`]" id="app_wrap"> 
        <p style="position: fixed; top: 50%; left: 0;">{{ themeColour }}</p>
        <!-- <DisablePage v-if="this.$store.state.isLoginNeed" /> -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import DisablePage from './components/DisablePage.vue';
import admin from '@/api/admin';

export default {
  name: 'MainHome',
  components: {
    DisablePage
  },
  computed: {
    themeColor() {
      return this.$store.state.theme.color;
    }
  },
  watch: {
    themeColor(newColor, oldColor) {
      const root = document.documentElement;
      root.removeAttribute(`data-${oldColor}`);
      root.setAttribute(`data-${newColor}`, true);
    }
  },
  created() {
    var flag = this.isMobile();
    // this.updateFavicon('/favicon.ico');
    this.$store.commit('setIsMobile',flag);

    // Theme Colour Set
    setTimeout(() => {
      const root = document.documentElement;
      root.setAttribute(`data-${this.$store.state.theme.color}`, true);
    }, 400);
    
    //모두 접속되도록 처리
    flag = true
    if(flag == false){
      alert('모바일 기기에서 접속해주세요')
      window.history.go(-1)
    }   
  },
  unmounted() {
    const root = document.documentElement;
    root.removeAttribute(`data-${this.$store.state.theme.color}`);
  },
  data() {
    return {
      theme: {
        color: "navy",
        font: "pretendard"
      },
    }
  },
  mounted(){
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // window.addEventListener('resize', this.upDateScreenSize)

  },
  methods: {
    updateFavicon(iconPath) { 
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = iconPath;
    },
    upDateScreenSize() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
  
    },
    isMobile(){
      const info = navigator.userAgent;
      var flag = false;

      if( info.indexOf("iPhone") > -1
          || info.indexOf("Android") > -1
          || info.indexOf("iPad") > -1
          || info.indexOf("iPod") > -1
      ) {
        flag = true;
      }
      return flag
    }
  }
}
</script>

<style lang="scss">
@import '@/style/font_set.module.scss';
@import '@/style/theme_set.module.scss';
@import '@/style/common.module.scss';

#app_wrap{
  min-height: calc(var(--vh, 1vh) * 100);
  ::-webkit-scrollbar{
    display: none;
  }
}

</style>